export default __webpack_public_path__ + "static/media/image-profile-cover-photo.6585aa54.svg";